import { observable, action } from "mobx";
import {post} from "../services/ajax.service";

class DawReviewStore {
  @observable spend_by_daw = [];
  @observable individual_spend_by_daw = [];
  @observable url ="/api/v1/insightactions/dawreview";
  

  
  @action getSpendByRaw = async data => {
      this.spend_by_daw = []
    try {
      let response = await post(
        `${this.url}/getSpendByRaw`,
        data
      );

      this.spend_by_daw = response.data;
    } catch (err) {
      console.log(err);
    }
  };


@action getIndividualSpendByRaw = async data => {
      this.individual_spend_by_daw = []
    try {
      let response = await post(
        `${this.url}/getIndividualSpendByRaw`,
        data
      );

      this.individual_spend_by_daw = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  
}

export default DawReviewStore;
